import React from "react";
import { motion } from "framer-motion";
import "../home.css";

import cert1 from "../Image/cert1.png";
import cert2 from "../Image/cert2.png";
import cert3 from "../Image/cert2.png";
const certificateData = [cert1, cert2, cert3];

const CertificateSection = () => {
  return (
    <div className="certificate-section">
      <motion.h2
        className="certificate-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Certificate
      </motion.h2>

      {/* Description */}
      <motion.p
        className="certificate-description"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
      Graduate with certifications that validate your expertise. From beginner to professional level, every program at Acadme ensures you walk away with credibility, competence, and a competitive edge.
      </motion.p>

      <div className="slider">
        <motion.div
          className="slide-track"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        >
          {[...certificateData, ...certificateData].map((img, index) => (
            <motion.div
              key={index}
              className="certificate-card"
              whileHover={{ scale: 1.1, y: -10, transition: { duration: 0.3 } }}
            >
              <img src={img} alt="certificate" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default CertificateSection;
